import React, { useEffect } from 'react';
import { Card, Row, Col, Carousel, Button, Container } from 'react-bootstrap';
import CategoryCard from './CategoryCard';
import Slider from 'react-slick';
import { useCategories } from '../../features/products/hooks/useCategory';
import { useProducts } from '../../features/products/hooks/useProducts';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Category = () => {

    const {
        categories,
        loading,
        fetchCategories,
    } = useCategories();

    const { countCategoryProduct, productsCountCategories } = useProducts();

    useEffect(() => {

    }, [fetchCategories, countCategoryProduct])

    const settings = {
        dots: true,
        infinite: true,
        speed: 5000,
        slidesToShow: 4,  // Show 3 items per slide
        slidesToScroll: 4,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024, // Below 1024px viewport width
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768, // Below 768px viewport width
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 480, // Below 480px viewport width
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
        ],
    };

    return (
        <Container
            className="mt-4 mb-4 pb-2"
            style={{ width: "100%", margin: "0 auto" }}>
            <Slider {...settings}>
                {productsCountCategories.map((pkg, idx) => (
                    <div
                        key={idx}
                        style={{
                            width: "90%", // Use a smaller percentage or fixed width
                            margin: "0 auto",
                            padding: "0 5px", // Add spacing between slides
                        }}
                    >
                        <CategoryCard data={pkg} />
                    </div>
                ))}
            </Slider>
        </Container>
    );
};

export default Category;